import links from '@/constants/links.js';

export default {
    list: [
        {
            id: 1,
            title: 'components.projects.list.0.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/amwgame.jpg',
            subtitle: 'components.projects.list.0.subtitle',
            brief: 'components.projects.list.0.brief',
            link: links.projects.amwCompanyPage,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 2,
            title: 'components.projects.list.1.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/animemixedworld.png',
            subtitle: 'components.projects.list.1.subtitle',
            brief: 'components.projects.list.1.brief',
            link: links.projects.amwPage,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 3,
            title: 'components.projects.list.2.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/tastetravellers.jpg',
            subtitle: 'components.projects.list.2.subtitle',
            brief: 'components.projects.list.2.brief',
            link: links.communities.tasteTravellers,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
    ]
}
